function truncate(str: string, max: number): string {
	return str.length > max ? `${str.slice(0, max - 1)}…` : str
}

export function generateParentPreviewText(html?: string): string {
	if (!html) {
		return ''
	}

	const doc = new DOMParser().parseFromString(html, 'text/html')
	const emojiReplacements: Record<string, string> = {
		IMG: '🖼️',
		AUDIO: '🔊',
	}

	const walker = document.createTreeWalker(
		doc.body,
		NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT,
	)
	let result = ''

	while (walker.nextNode()) {
		const node = walker.currentNode

		if (node.nodeType === Node.ELEMENT_NODE) {
			const el = node as HTMLElement

			// Emoji replacements
			if (emojiReplacements[el.tagName]) {
				result += `${emojiReplacements[el.tagName]} `
			}

			// Anchor = 🔗
			if (el.tagName === 'A') {
				result += '🔗 '
			}

			// List item = add bullet
			if (el.tagName === 'LI') {
				result += '• '
			}
		}

		if (node.nodeType === Node.TEXT_NODE) {
			const text = node.textContent || ''
			result += text
		}
	}

	// Replace raw URLs
	result = result.replace(/https?:\/\/\S+/g, '🔗')

	// Inside your function, after cleaning whitespace:
	return truncate(result.replace(/\s+/g, ' ').trim(), 100)
}
